import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Slot, Slottable, Spinner, Text, } from "@radix-ui/themes";
import { CheckIcon } from "@radix-ui/react-icons";
import { useEffect, useRef, useState } from "react";
import { namespaceClassNames } from "./utils";
const DONE_TIMEOUT_MS = 1500;
const SAVING_TIMEOUT_MS = 600;
export function SaveButton({ asChild = false, children, loading, done, onDone, ...props }) {
    const [state, setState] = useState(loading ? "loading" : done ? "done" : "idle");
    const loadingStartTime = useRef(null);
    const Button = asChild ? Slot : "button";
    useEffect(() => {
        if (loading) {
            setState("loading");
            loadingStartTime.current = Date.now();
        }
        else if (done) {
            const currentTime = Date.now();
            const loadingDuration = loadingStartTime.current
                ? currentTime - loadingStartTime.current
                : 0;
            // If loading lasted less than 500 ms, wait for the remaining time
            const remainingDelay = Math.max(0, SAVING_TIMEOUT_MS - loadingDuration);
            let doneTimer = null;
            const savedTimer = setTimeout(() => {
                setState("done");
                doneTimer = setTimeout(() => {
                    onDone?.();
                }, DONE_TIMEOUT_MS);
            }, remainingDelay);
            return () => {
                clearTimeout(savedTimer);
                if (doneTimer) {
                    clearTimeout(doneTimer);
                }
            };
        }
        else if (!loading && !done) {
            setState("idle");
        }
    }, [loading, done, onDone]);
    return (_jsxs(Button, { ...props, className: namespaceClassNames("save-button"), "data-save-state": state, children: [_jsx(Slottable, { children: children }), state === "loading" && (_jsx(Flex, { as: "span", align: "center", justify: "center", position: "absolute", inset: "0", children: _jsx(Spinner, { size: "1" }) })), state === "done" && (_jsxs(Flex, { as: "span", align: "center", justify: "center", position: "absolute", inset: "0", gap: "1", children: [_jsx(CheckIcon, { width: "18px", height: "18px", style: { marginLeft: "-4px" }, className: namespaceClassNames("save-button__done-icon") }), _jsx(Text, { className: namespaceClassNames("save-button__done-text"), children: "Done" })] }))] }));
}
//# sourceMappingURL=save-button.js.map